import { useNavigate } from "react-router";
import { GetImages } from "../../../utils/GetImages";
import { useState } from "react";
import SelectPlanButton from "./common/SelectPlanButton";

const MySubscriptionPlanComponent = () => {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState('trial')

  const features = [
    { name: 'Units', trial: 'No Minimum (Upto 20 Units)', lite: 'No Minimum (Upto 50 Units)', pro: 'No Minimum (Unlimited)' },
    { name: 'Property Management', trial: true, lite: true, pro: true },
    { name: 'Unit Management', trial: true, lite: true, pro: true },
    { name: 'Tenant Management', trial: true, lite: true, pro: true },
    { name: 'Online Rent Collection', trial: true, lite: true, pro: true },
    { name: 'Contractor Management', trial: true, lite: true, pro: true },
    { name: 'Team Management', trial: true, lite: true, pro: true },
    { name: 'Document Management', trial: true, lite: true, pro: true },
    { name: 'Team Management', trial: true, lite: true, pro: true },
    { name: 'Maintenance Management', trial: true, lite: true, pro: true },
    { name: 'Communications', trial: true, lite: true, pro: true },
    { name: 'Accounting', trial: 'Basic', lite: 'Basic', pro: 'Advanced' },
    { name: 'Reporting', trial: 'Basic', lite: 'Basic', pro: 'Advanced' },
    { name: 'AI Chatbot', trial: 'Basic', lite: 'Basic', pro: 'Personalized' },
    { name: 'Tenant Web Portal & Mobile App', trial: true, lite: true, pro: true },
    { name: 'Lease Management', trial: true, lite: true, pro: true },
    { name: 'Owner Management', trial: 'Single', lite: 'Multiple', pro: 'Multiple' },
    { name: 'E-Signatures', trial: false, lite: false, pro: true },
    { name: 'Tenant Onboarding', trial: false, lite: false, pro: true },
    { name: 'Multiple Portfolio Management', trial: false, lite: false, pro: true },
    { name: 'Integrated Scheduling', trial: false, lite: false, pro: true },
    { name: 'Tasks Management w/ Reminders', trial: false, lite: false, pro: true },
    { name: 'Owner Web Portal & Mobile App', trial: false, lite: false, pro: true },
    { name: 'Property Management Services', trial: false, lite: false, pro: true },
    { name: 'Tax Documents', trial: false, lite: false, pro: true },
    { name: 'Inspections Management', trial: false, lite: false, pro: true },
    { name: 'Advanced Lease Terms', trial: false, lite: false, pro: true },
    { name: 'List vacancies on 3rd party sites', trial: false, lite: false, pro: true },
    { name: 'Multi-Language Support', trial: false, lite: false, pro: true },
    { name: 'Branded Website w/ listings', trial: false, lite: false, pro: true },
    { name: 'Branded Web Portal', trial: false, lite: false, pro: false },
    { name: 'Branded Mobile Apps', trial: false, lite: false, pro: false },
    { name: 'Custom Domain', trial: false, lite: false, pro: false },
    { name: 'Support', trial: 'Email', lite: 'Email', pro: 'Email/Phone' },
    { name: 'Customized Integrations', trial: false, lite: false, pro: false },
    { name: 'Upload/Download Support', trial: false, lite: false, pro: false },
    { name: 'On-Premise Deployment', trial: false, lite: false, pro: false },
    { name: 'Software Updates', trial: true, lite: true, pro: true },
    { name: 'One Time Onboarding Fee (Optional)', trial: '250', lite: '500', pro: '1000' },
    { name: 'Backend Admin Support', trial: false, lite: false, pro: 'Yes*' },
    {
      name: '',
      trial: <SelectPlanButton onClick={null} label="Select" />,
      lite: <SelectPlanButton onClick={null} label="Select" />,
      pro: <SelectPlanButton onClick={null} label="Select" />
    },
  ]

  return (
    <div className="Subcription-Container">
      <div className="Subcription_breadcrumb">
        <div className="SubcriptionTopbar">
          <div
            onClick={() => {
              navigate("/");
            }}
            className="clickable"
          >
            <p className="normal_text fw-500 black">Dashboard</p>
          </div>
          <img src={GetImages.BlackChevronRight} />
          <p
            onClick={() => {
              navigate("/organization", { state: true });
            }}
            className="normal_text fw-500 black clickable"
          >
            My Subscription
          </p>
          <img src={GetImages.BlackChevronRight} />
          <p className="normal_texzt fw-500 grey">Subscription Plan</p>
        </div>
      </div>

      <div className="Subcription_Wrapper">
        <div className="Subcription-Back-Button px-4">
          <img onClick={() => { navigate("/platform-settings/mysubscription") }}
            height={28}
            width={28}
            src={GetImages.leftChevronBlack}
            className="clickable"
          />
          <h5 className="sub_heading">My Subscription</h5>
        </div>

        <div className="Price-table-Container">
          <table className="table table-bordered Price-table">
            <thead>
              <tr>
                <th className="text-center sub_heading">Features</th>

                <th className={selectedPlan === 'trial' ? 'active-column' : ''}>
                  <div className="round">
                    <input
                      type="checkbox"
                      name="subscription"
                      id="trial"
                      checked={selectedPlan === 'trial'}
                      onChange={() => setSelectedPlan('trial')}
                    />
                    <label htmlFor="trial"></label>
                    <span className={`px-2 sub_heading ${selectedPlan === 'trial' ? 'checkbox-lable-text-white' : ''}`}>Trial</span>
                  </div>
                </th>

                <th className={selectedPlan === 'lite' ? 'active-column' : ''}>
                  <div className="round">
                    <input
                      type="checkbox"
                      name="subscription"
                      id="lite"
                      checked={selectedPlan === 'lite'}
                      onChange={() => setSelectedPlan('lite')}
                    />
                    <label htmlFor="lite"></label>
                    <span className={`px-2 sub_heading ${selectedPlan === 'lite' ? 'checkbox-lable-text-white' : ''}`}>Lite</span>
                  </div>
                </th>

                <th className={selectedPlan === 'pro' ? 'active-column' : ''}>
                  <div className="round">
                    <input
                      type="checkbox"
                      name="subscription"
                      id="pro"
                      checked={selectedPlan === 'pro'}
                      onChange={() => setSelectedPlan('pro')}
                    />
                    <label htmlFor="pro"></label>
                    <span className={`px-2 sub_heading ${selectedPlan === 'pro' ? 'checkbox-lable-text-white' : ''}`}>Pro</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>

              {features.map((feature, index) => (
                <tr key={index}>
                  <td className="sub_text grey_subtext1">{feature.name}</td>
                  <td className={`sub_text grey_subtext1 ${selectedPlan === 'trial' ? 'table-td-bg-color' : ''}`}>
                    {typeof feature.trial === 'boolean' ? (
                      feature.trial ?
                        (
                          <img src={GetImages.CheckGreenIcon} className="Icon20" />
                        ) : (
                          <img src={GetImages.closeRedIcon} className="iconstyle18" />
                        )
                    ) : (
                      feature.trial
                    )}
                  </td>
                  <td className={`sub_text grey_subtext1 ${selectedPlan === 'lite' ? 'table-td-bg-color' : ''}`}>
                    {typeof feature.lite === 'boolean' ? (
                      feature.lite ?
                        (
                          <img src={GetImages.CheckGreenIcon} className="Icon20" />
                        ) : (
                          <img src={GetImages.closeRedIcon} className="iconstyle18" />
                        )
                    ) : (
                      feature.lite
                    )}
                  </td>
                  <td className={`sub_text grey_subtext1 ${selectedPlan === 'pro' ? 'table-td-bg-color' : ''}`}>
                    {typeof feature.pro === 'boolean' ? (
                      feature.pro ?
                        (
                          <img src={GetImages.CheckGreenIcon} className="Icon20" />
                        ) : (
                          <img src={GetImages.closeRedIcon} className="iconstyle18" />
                        )
                    ) : (
                      feature.pro
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
};


export default MySubscriptionPlanComponent;

